import { DownloadTableExcel } from "react-export-table-to-excel";
import React from 'react'

import { toast, ToastContainer } from "react-toastify";
import Dashboardnavbar from "../../../layout/Dashboardnavbar";
import { useEffect, useRef, useState } from "react";
import usePermission from "../../../config/permissions";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../../config/axios";
import { handleErrorToast, sortProjects, ViewDynamicApprovalStatus, ViewDynamicboqStatus } from "../../../components/CustomFunctions";
import InvoiceList from "../../../components/SiteManagement/AdminSiteManagement/InvoiceList";
import { AddBOQInvoice, Generateconsultantinvoicebyproject } from "../../../components/SiteManagement/ProjectDetailsCrudButtons";
import { CircularGrid, Eye, SearchBig, SearchSmall, Sort, Reciept } from "../../../components/AllSvg";
import { SubCompany } from "../../../components/FilterDropdown";
import { ViewReciept } from "../../../components/CustomFunctions";
import { ChevronDown, ChevronUp, FileText, Filter, ReceiptIndianRupeeIcon, Search, X } from "lucide-react";

import { LayoutDashboard, Table as TableIcon } from "lucide-react"; // merge into your existing lucide-react import
import InvoiceDashboard from "../../../components/Dashborad/InvoiceDashboard";

const Boqinvoices = () => {
  const tableRef = useRef(null);
  const subcompanyid = sessionStorage.getItem("sitemanagement_project_sub_company");

  const siteRole = sessionStorage.getItem("sitemanagement_role");
  const { PERMISSION_AUTHORITY } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(subcompanyid || "null");
  const [filteredData, setFilteredData] = useState([]);
  const [sorting, setSorting] = useState("asc_pr");
  const projectid = sessionStorage.getItem('sitemanagement_project');
  const [invoice, setInvoice] = useState([]);
  const [showFilters, setShowFilters] = useState(true);

  // NEW: "table" | "dashboard"
  const [view, setView] = useState("table");

  const [projectsList, setProjectsList] = useState([]);
  const [projects, setProjects] = useState("");
  const [selectedName, setName] = useState("");
  const [error, setError] = useState(null);



  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const navigate = useNavigate();
  const empID = sessionStorage.getItem('sitemanagement_emp_id');

  const [buffer, setBuffering] = useState(true); //buffering logic

  const getProjects = async (filters = {}) => {
    setBuffering(true); //buffering logic // Start BufferingDD
    try {
      const params = new URLSearchParams();
      if (filters.id) params.append('id', filters.id);
      if (filters.sub_company) params.append('sub_company', filters.sub_company);
      if (filters.current_level) params.append('current_level', filters.current_level);
      if (filters.com_operator) params.append('com_operator', filters.com_operator);
      if (filters.current_status) params.append('current_status', filters.current_status);
      if (filters.previous_approval_status)
        params.append('previous_approval_status', filters.previous_approval_status);
      const query = params.toString();
      const queryString = query ? `?${query}` : '';

      let url;


      sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
        url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
        : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
          url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
          : siteRole === "SiteManagement" ?
            url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
            : url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`;


      const ress = await axios.get(url);
      if (siteRole === "SiteManagement") {
        setProjects(ress.data);
      }
      else {
        const sortedList = sortProjects(ress.data, "site_prcode");

        setProjectsList(sortedList);
      }




    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {

    if (siteRole === "DataEntryOperator") {
      getProjects({ com_operator: empID });
    }
    else if (siteRole === "AuthorityEngineer") {
      getProjects({ authority_engineer: empID });
    }
    else if (siteRole === "SiteManagement") {
      getProjects({ id: projectid });
    }
    else {
      getProjects({ sub_company: toggleCompany });
    }
  }, [toggleCompany, sorting, empID, projectid]);

  useEffect(() => {
    getInvoice();
  }, [projectid])

  useEffect(() => {
    applyFilters();
  }, [projectsList, selectedName, sorting]);

  const applyFilters = () => {
    let tempFilteredData = projectsList;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      tempFilteredData = tempFilteredData.filter((employee) => {
        const nameMatch = employee.site_prcode.toString().toLowerCase().includes(lowercaseSelectedName);
        const empCodeMatch = employee.project_short_name.toLowerCase().includes(lowercaseSelectedName);
        return nameMatch || empCodeMatch;
      });
    }

    switch (sorting) {
      case "asc_pr":
        tempFilteredData = sortProjects(tempFilteredData, "site_prcode");
        break;
      case "desc_pr":
        tempFilteredData = sortProjects(tempFilteredData, "site_prcode").reverse();
        break;
      case "asc_short_name":
        tempFilteredData = tempFilteredData.sort((a, b) =>
          a.project_short_name.localeCompare(b.project_short_name)
        );
        break;
      case "desc_short_name":
        tempFilteredData = tempFilteredData.sort((a, b) =>
          b.project_short_name.localeCompare(a.project_short_name)
        );
        break;
      default:
        break;
    }

    setFilteredData(tempFilteredData);
  };



  const ViewBOQ = (project, sub_company) => {
    navigate(`/${urlParts[3]}/Invoiceformate/${project}/${sub_company}/`
    );
  };


  const getInvoice = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${projectid}/null/null/`);
      const sortedInvoices = response.data.sort((a, b) => {
        if (a.year !== b.year) {
          return b.year - a.year; // Sort by year first
        }
        return b.month - a.month; // If years are the same, sort by month
      });
      setInvoice(sortedInvoices);
    } catch (error) {
      console.error(error);
    }
  };


  const ViewInvoice = (invoice_id, month, invoice_number, year) => {
    navigate(`/${urlParts[3]}/ConsultancyInvoice/${projectid}/${invoice_id}/`, { state: { invoice_id, projectid, month, year, invoice_number } });
  };

  const ViewPaymentReceipt = (invoice_id, month, invoice_number, year) => {
    navigate(`/${urlParts[3]}/PrintInvoice/${projectid}/${invoice_id}/`, { state: { invoice_id, projectid, month, year, invoice_number } });
  };

  const hasActiveFilters = (toggleCompany !== "null") || selectedName !== "" || sorting !== "asc_pr";

  const clearAllFilters = () => {
    setToggleCompany("null");
    setName("");
    setSorting("asc_pr");
  };
  const mergeDynamicStagesWithApprovals = (dynamicStages = [], dynamicApprovals = []) => {
    return dynamicStages.map((stage) => {
      const approvalForLevel = dynamicApprovals.find(
        (approval) => approval.level === stage.level
      );

      // agar is level ka approval data maujood hai, wahi use karo (stage ko replace)
      // warna original stage data hi rakho
      return approvalForLevel ? { ...approvalForLevel, isApproval: true } : { ...stage, isApproval: false };
    });
  };

  // NEW: Table / Dashboard toggle button
  const viewBtn = (key, label, Icon) => (
    <button
      key={key}
      onClick={() => setView(key)}
      style={{
        display: "flex", alignItems: "center", gap: 6, padding: "6px 14px",
        border: "none", borderRadius: 6, cursor: "pointer", fontSize: 13, fontWeight: 600,
        background: view === key ? "#14213D" : "transparent",
        color: view === key ? "#fff" : "#555",
        transition: "all .15s ease",
      }}
    >
      <Icon size={14} />
      {label}
    </button>
  );

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="content-tabs">
        <div className="progress-modern-container">

          {view === "table" && siteRole !== "SiteManagement" && showFilters && (
            <div className="filter-bar-attractive">
              <div className="filter-group-attractive">
                {PERMISSION_AUTHORITY && (
                  <div className={`filter-chip ${toggleCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                    <div className="filter-chip-content">
                      <SubCompany toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} />
                    </div>
                  </div>
                )}

                <div className={`filter-chip ${sorting !== "asc_pr" ? "active" : ""}`}>
                  <div><Sort /></div>
                  <div className="filter-chip-content">
                    <select
                      className="modern-select"
                      value={sorting}
                      onChange={(e) => setSorting(e.target.value)}
                      style={{ cursor: 'pointer' }}
                    >
                      <option value="asc_pr">Asc. Pr Code</option>
                      <option value="desc_pr">Desc. Pr Code</option>
                      <option value="asc_short_name">Asc. Project Name</option>
                      <option value="desc_short_name">Desc. Project Name</option>
                    </select>
                  </div>
                </div>

                <div className={`filter-chip ${selectedName !== "" ? "active" : ""}`} style={{ minWidth: '240px' }}>
                  <div><Search size={15} /></div>
                  <div className="filter-chip-content" style={{ width: '100%' }}>
                    <input
                      className="modern-select"
                      style={{ width: '100%' }}
                      placeholder="Code / Project Name"
                      value={selectedName}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </div>

                {hasActiveFilters && (
                  <button className="clear-filters-btn" onClick={clearAllFilters}>
                    <X size={13} />
                    Clear
                  </button>
                )}
              </div>
            </div>
          )}

          <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              {/* NEW: view toggle */}
              <div style={{ display: "flex", gap: 4, padding: 3, background: "#EEF1F5", borderRadius: 8 }}>
                {viewBtn("table", "Table view", TableIcon)}
                {viewBtn("dashboard", "Dashboard view", LayoutDashboard)}
              </div>

              {view === "table" && (
                <div className="stats-minimal-row">
                  <div className="stat-minimal-item">
                    <FileText size={14} />
                    <span>Showing</span>
                    <strong>{siteRole === "SiteManagement" ? invoice.length : filteredData.length} {siteRole === "SiteManagement" ? "invoices" : "projects"}</strong>
                  </div>
                </div>
              )}
            </div>

            {view === "table" && (
              <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                {siteRole !== "SiteManagement" && (
                  <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                    <Filter size={14} />
                    <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                    {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                  </button>
                )}

                {siteRole !== "ViewAccess" && siteRole !== "BD" && (
                  <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                    <AddBOQInvoice getInvoice={getProjects} />
                  </div>
                )}
              </div>
            )}
          </div>

          {view === "dashboard" ? (
            /* NEW: dashboard view */
            <InvoiceDashboard baseUrl={`${BASE_URL}/siteproject/invoicedashboard`} />
          ) : (
            <div className="table-wrapper-minimal table-box scroll-container-table">
              {buffer ? (
                <div className="loader-minimal">
                  <div className="spinner-minimal"></div>
                </div>
              ) : siteRole === "SiteManagement" ? (
                <table className="progress-table-minimal" ref={tableRef}>
                  <thead className="table-heading">
                    <tr>
                      <th className="col-sno" style={{ width: '6%' }}>#</th>
                      <th className="col-period text-center">Invoice Number</th>
                      <th className="col-submitted text-center">Month</th>
                      <th className="col-submitted text-center">Year</th>
                      <th className="col-status text-center">View Invoice</th>
                      <th className="col-action text-center">Payment Receipt</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.length > 0 ? (
                      invoice.map((inv, index) => (
                        <tr className="progress-row" key={index}>
                          <td className="col-sno text-start">{index + 1}</td>
                          <td className="col-period text-center">{inv.invoice_number}</td>
                          <td className="col-submitted text-center">{inv.month}</td>
                          <td className="col-submitted text-center">{inv.year}</td>
                          <td className="col-status text-center">
                            <button
                              className="action-icon actionn-icon"
                              style={{ backgroundColor: "#00000075" }}
                              onClick={() => ViewInvoice(inv.id, inv.month, inv.invoice_number, inv.year)}
                              title="View Invoice"
                            >
                              <FileText size={16} color="white" />
                            </button>
                          </td>
                          <td className="col-action text-center">
                            <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                              <button
                                className="action-icon actionn-icon"
                                style={{ backgroundColor: "#00000075" }}
                                onClick={() => ViewPaymentReceipt(inv.id, inv.month, inv.invoice_number, inv.year)}
                                title="View Payment Receipt"
                              >
                                <ReceiptIndianRupeeIcon size={20} color="white" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>
                          <div className="empty-state-attractive">
                            <div className="empty-state-icon-wrap">
                              <FileText size={32} />
                            </div>
                            <h4 className="empty-state-title">No Invoices Found</h4>
                            <p className="empty-state-subtitle">There are no invoices generated for this project yet.</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                <table className="progress-table-minimal" ref={tableRef}>
                  <thead className="table-heading" style={{ zIndex: 999 }}>
                    <tr >
                      <th className="col-sno" style={{ width: '6%' }}>#</th>
                      <th className="col-period text-left">Project Code</th>
                      <th className="col-period text-center">Project Name</th>
                      <th className="col-status text-center">View BOQ</th>
                      <th className="col-status text-start" style={{ width: '20%' }}>Approval Status</th>

                      {siteRole !== "BD" && <th className="col-action text-center">View Invoice</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((project, index) => (
                        <tr className="progress-row" key={index}>
                          <td className="col-sno text-start">{index + 1}</td>
                          <td className="col-period text-left">{project?.site_prcode}</td>
                          <td className="col-period text-center">{project.project_short_name}</td>
                          <td className="col-status text-center">
                            <button
                              className="action-icon"
                              style={{ backgroundColor: "#00000075" }}
                              onClick={() => ViewBOQ(project.id, project.sub_company)}
                              title="View BOQ Details"
                            >
                              <FileText size={16} color="white" />
                            </button>
                          </td>
                          <td className="col-status text-center">
                            <ViewDynamicboqStatus dynamic_approval={mergeDynamicStagesWithApprovals(project.dynamic_stages, project.dynamic_approvals)} Table="Project" />
                          </td>
                          {siteRole !== "BD" && (
                            <td className="col-action text-center">
                              <InvoiceList project={project} />
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={siteRole !== "BD" ? 5 : 4}>
                          <div className="empty-state-attractive">
                            <div className="empty-state-icon-wrap">
                              <FileText size={32} />
                            </div>
                            <h4 className="empty-state-title">No Projects Found</h4>
                            <p className="empty-state-subtitle">
                              Try adjusting your filters or search to find what you're looking for.
                            </p>
                            {hasActiveFilters && siteRole === "Admin" && (
                              <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear Filters
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};


// const Boqinvoices = () => {
//   const tableRef = useRef(null);
//   const subcompanyid = sessionStorage.getItem("sitemanagement_project_sub_company");

//   const siteRole = sessionStorage.getItem("sitemanagement_role");
//   const { PERMISSION_AUTHORITY } = usePermission();
//   const [toggleCompany, setToggleCompany] = useState(subcompanyid || "null");
//   const [filteredData, setFilteredData] = useState([]);
//   const [sorting, setSorting] = useState("asc_pr");
//   const projectid = sessionStorage.getItem('sitemanagement_project');
//   const [invoice, setInvoice] = useState([]);
//   const [showFilters, setShowFilters] = useState(true);


//   const [projectsList, setProjectsList] = useState([]);
//   const [projects, setProjects] = useState("");
//   const [selectedName, setName] = useState("");
//   const [error, setError] = useState(null);



//   const currentUrl = window.location.href;
//   const urlParts = currentUrl.split("/");
//   const navigate = useNavigate();
//   const empID = sessionStorage.getItem('sitemanagement_emp_id');

//   const [buffer, setBuffering] = useState(true); //buffering logic

//   const getProjects = async (filters = {}) => {
//     setBuffering(true); //buffering logic // Start BufferingDD
//     try {
//       const params = new URLSearchParams();
//       if (filters.id) params.append('id', filters.id);
//       if (filters.sub_company) params.append('sub_company', filters.sub_company);
//       if (filters.current_level) params.append('current_level', filters.current_level);
//       if (filters.com_operator) params.append('com_operator', filters.com_operator);
//       if (filters.current_status) params.append('current_status', filters.current_status);
//       if (filters.previous_approval_status)
//         params.append('previous_approval_status', filters.previous_approval_status);
//       const query = params.toString();
//       const queryString = query ? `?${query}` : '';

//       let url;


//       sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
//         url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
//         : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
//           url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
//           : siteRole === "SiteManagement" ?
//             url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`
//             : url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`;


//       const ress = await axios.get(url);
//       if (siteRole === "SiteManagement") {
//         setProjects(ress.data);
//       }
//       else {
//         const sortedList = sortProjects(ress.data, "site_prcode");

//         setProjectsList(sortedList);
//       }




//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false); // End Buffering
//     }
//   };

//   useEffect(() => {

//     if (siteRole === "DataEntryOperator") {
//       getProjects({ com_operator: empID });
//     }
//     else if (siteRole === "AuthorityEngineer") {
//       getProjects({ authority_engineer: empID });
//     }
//     else if (siteRole === "SiteManagement") {
//       getProjects({ id: projectid });
//     }
//     else {
//       getProjects({ sub_company: toggleCompany });
//     }
//   }, [toggleCompany, sorting, empID, projectid]);

//   useEffect(() => {
//     getInvoice();
//   }, [projectid])

//   useEffect(() => {
//     applyFilters();
//   }, [projectsList, selectedName, sorting]);

//   const applyFilters = () => {
//     let tempFilteredData = projectsList;

//     if (selectedName) {
//       const lowercaseSelectedName = selectedName.toLowerCase();
//       tempFilteredData = tempFilteredData.filter((employee) => {
//         const nameMatch = employee.site_prcode.toString().toLowerCase().includes(lowercaseSelectedName);
//         const empCodeMatch = employee.project_short_name.toLowerCase().includes(lowercaseSelectedName);
//         return nameMatch || empCodeMatch;
//       });
//     }

//     switch (sorting) {
//       case "asc_pr":
//         tempFilteredData = sortProjects(tempFilteredData, "site_prcode");
//         break;
//       case "desc_pr":
//         tempFilteredData = sortProjects(tempFilteredData, "site_prcode").reverse();
//         break;
//       case "asc_short_name":
//         tempFilteredData = tempFilteredData.sort((a, b) =>
//           a.project_short_name.localeCompare(b.project_short_name)
//         );
//         break;
//       case "desc_short_name":
//         tempFilteredData = tempFilteredData.sort((a, b) =>
//           b.project_short_name.localeCompare(a.project_short_name)
//         );
//         break;
//       default:
//         break;
//     }

//     setFilteredData(tempFilteredData);
//   };



//   const ViewBOQ = (project, sub_company) => {
//     navigate(`/${urlParts[3]}/Invoiceformate/${project}/${sub_company}/`
//     );
//   };


//   const getInvoice = async () => {
//     try {
//       const response = await axios.get(`${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${projectid}/null/null/`);
//       const sortedInvoices = response.data.sort((a, b) => {
//         if (a.year !== b.year) {
//           return b.year - a.year; // Sort by year first
//         }
//         return b.month - a.month; // If years are the same, sort by month
//       });
//       setInvoice(sortedInvoices);
//     } catch (error) {
//       console.error(error);
//     }
//   };


//   const ViewInvoice = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/ConsultancyInvoice/${projectid}/${invoice_id}/`, { state: { invoice_id, projectid, month, year, invoice_number } });
//   };

//   const ViewPaymentReceipt = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/PrintInvoice/${projectid}/${invoice_id}/`, { state: { invoice_id, projectid, month, year, invoice_number } });
//   };

//   const hasActiveFilters = (toggleCompany !== "null") || selectedName !== "" || sorting !== "asc_pr";

//   const clearAllFilters = () => {
//     setToggleCompany("null");
//     setName("");
//     setSorting("asc_pr");
//   };
//   const mergeDynamicStagesWithApprovals = (dynamicStages = [], dynamicApprovals = []) => {
//     return dynamicStages.map((stage) => {
//       const approvalForLevel = dynamicApprovals.find(
//         (approval) => approval.level === stage.level
//       );

//       // agar is level ka approval data maujood hai, wahi use karo (stage ko replace)
//       // warna original stage data hi rakho
//       return approvalForLevel ? { ...approvalForLevel, isApproval: true } : { ...stage, isApproval: false };
//     });
//   };

//   return (
//     <>
//       <ToastContainer
//         position="top-center"
//         autoClose={1000}
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//       />

//       <div className="content-tabs">
//         <div className="progress-modern-container">

//           {siteRole !== "SiteManagement" && showFilters && (
//             <div className="filter-bar-attractive">
//               <div className="filter-group-attractive">
//                 {PERMISSION_AUTHORITY && (
//                   <div className={`filter-chip ${toggleCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
//                     <div className="filter-chip-content">
//                       <SubCompany toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} />
//                     </div>
//                   </div>
//                 )}

//                 <div className={`filter-chip ${sorting !== "asc_pr" ? "active" : ""}`}>
//                   <div><Sort /></div>
//                   <div className="filter-chip-content">
//                     <select
//                       className="modern-select"
//                       value={sorting}
//                       onChange={(e) => setSorting(e.target.value)}
//                       style={{ cursor: 'pointer' }}
//                     >
//                       <option value="asc_pr">Asc. Pr Code</option>
//                       <option value="desc_pr">Desc. Pr Code</option>
//                       <option value="asc_short_name">Asc. Project Name</option>
//                       <option value="desc_short_name">Desc. Project Name</option>
//                     </select>
//                   </div>
//                 </div>

//                 <div className={`filter-chip ${selectedName !== "" ? "active" : ""}`} style={{ minWidth: '240px' }}>
//                   <div><Search size={15} /></div>
//                   <div className="filter-chip-content" style={{ width: '100%' }}>
//                     <input
//                       className="modern-select"
//                       style={{ width: '100%' }}
//                       placeholder="Code / Project Name"
//                       value={selectedName}
//                       onChange={(e) => setName(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 {hasActiveFilters && (
//                   <button className="clear-filters-btn" onClick={clearAllFilters}>
//                     <X size={13} />
//                     Clear
//                   </button>
//                 )}
//               </div>
//             </div>
//           )}

//           <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
//             <div className="stats-minimal-row">
//               <div className="stat-minimal-item">
//                 <FileText size={14} />
//                 <span>Showing</span>
//                 <strong>{siteRole === "SiteManagement" ? invoice.length : filteredData.length} {siteRole === "SiteManagement" ? "invoices" : "projects"}</strong>
//               </div>
//             </div>

//             <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
//               {siteRole !== "SiteManagement" && (
//                 <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
//                   <Filter size={14} />
//                   <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
//                   {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
//                 </button>
//               )}

//               {siteRole !== "ViewAccess" && siteRole !== "BD" && (
//                 <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
//                   <AddBOQInvoice getInvoice={getProjects} />
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="table-wrapper-minimal table-box scroll-container-table">
//             {buffer ? (
//               <div className="loader-minimal">
//                 <div className="spinner-minimal"></div>
//               </div>
//             ) : siteRole === "SiteManagement" ? (
//               <table className="progress-table-minimal" ref={tableRef}>
//                 <thead className="table-heading">
//                   <tr>
//                     <th className="col-sno" style={{ width: '6%' }}>#</th>
//                     <th className="col-period text-center">Invoice Number</th>
//                     <th className="col-submitted text-center">Month</th>
//                     <th className="col-submitted text-center">Year</th>
//                     <th className="col-status text-center">View Invoice</th>
//                     <th className="col-action text-center">Payment Receipt</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {invoice.length > 0 ? (
//                     invoice.map((inv, index) => (
//                       <tr className="progress-row" key={index}>
//                         <td className="col-sno text-start">{index + 1}</td>
//                         <td className="col-period text-center">{inv.invoice_number}</td>
//                         <td className="col-submitted text-center">{inv.month}</td>
//                         <td className="col-submitted text-center">{inv.year}</td>
//                         <td className="col-status text-center">
//                           <button
//                             className="action-icon actionn-icon"
//                             style={{ backgroundColor: "#00000075" }}
//                             onClick={() => ViewInvoice(inv.id, inv.month, inv.invoice_number, inv.year)}
//                             title="View Invoice"
//                           >
//                             <FileText size={16} color="white" />
//                           </button>
//                         </td>
//                         <td className="col-action text-center">
//                           <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
//                             <button
//                               className="action-icon actionn-icon"
//                               style={{ backgroundColor: "#00000075" }}
//                               onClick={() => ViewPaymentReceipt(inv.id, inv.month, inv.invoice_number, inv.year)}
//                               title="View Payment Receipt"
//                             >
//                               <ReceiptIndianRupeeIcon size={20} color="white" />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={6}>
//                         <div className="empty-state-attractive">
//                           <div className="empty-state-icon-wrap">
//                             <FileText size={32} />
//                           </div>
//                           <h4 className="empty-state-title">No Invoices Found</h4>
//                           <p className="empty-state-subtitle">There are no invoices generated for this project yet.</p>
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             ) : (
//               <table className="progress-table-minimal" ref={tableRef}>
//                 <thead className="table-heading" style={{ zIndex: 999 }}>
//                   <tr >
//                     <th className="col-sno" style={{ width: '6%' }}>#</th>
//                     <th className="col-period text-left">Project Code</th>
//                     <th className="col-period text-center">Project Name</th>
//                     <th className="col-status text-center">View BOQ</th>
//                     <th className="col-status text-start" style={{ width: '20%' }}>Approval Status</th>

//                     {siteRole !== "BD" && <th className="col-action text-center">View Invoice</th>}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.length > 0 ? (
//                     filteredData.map((project, index) => (
//                       <tr className="progress-row" key={index}>
//                         <td className="col-sno text-start">{index + 1}</td>
//                         <td className="col-period text-left">{project?.site_prcode}</td>
//                         <td className="col-period text-center">{project.project_short_name}</td>
//                         <td className="col-status text-center">
//                           <button
//                             className="action-icon"
//                             style={{ backgroundColor: "#00000075" }}
//                             onClick={() => ViewBOQ(project.id, project.sub_company)}
//                             title="View BOQ Details"
//                           >
//                             <FileText size={16} color="white" />
//                           </button>
//                         </td>
//                         <td className="col-status text-center">
//                           <ViewDynamicboqStatus dynamic_approval={mergeDynamicStagesWithApprovals(project.dynamic_stages, project.dynamic_approvals)} Table="Project" />
//                         </td>
//                         {siteRole !== "BD" && (
//                           <td className="col-action text-center">
//                             <InvoiceList project={project} />
//                           </td>
//                         )}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={siteRole !== "BD" ? 5 : 4}>
//                         <div className="empty-state-attractive">
//                           <div className="empty-state-icon-wrap">
//                             <FileText size={32} />
//                           </div>
//                           <h4 className="empty-state-title">No Projects Found</h4>
//                           <p className="empty-state-subtitle">
//                             Try adjusting your filters or search to find what you're looking for.
//                           </p>
//                           {hasActiveFilters && siteRole === "Admin" && (
//                             <button className="empty-state-clear-btn" onClick={clearAllFilters}>
//                               <X size={13} />
//                               Clear Filters
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };


export default Boqinvoices
